import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from './core/i18n/language.service';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { errorInterceptor } from './core/error/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21 defaults to zoneless; keep ZoneJS so HTTP/subscribe updates refresh the UI.
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: `.json?v=${environment.i18nVersion}`
      }),
      fallbackLang: FALLBACK_LANGUAGE,
      lang: DEFAULT_LANGUAGE
    })
  ]
};
